package com.shadowings.gero.data.lessons.chapter9

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.Option
import com.shadowings.gero.domain.model.SingleSelectionContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_1
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_2
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_3
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_4
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_5
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_6
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_7
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_8
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_9
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_10
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_11
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_12
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_13
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_14
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_15
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_16
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_17
import gero.composeapp.generated.resources.exp_content_frasi_avverbiali_18
import gero.composeapp.generated.resources.exp_title_frasi_avverbiali
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_1
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_2
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_3
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_4
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_5
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_6
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_6_opt1
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_6_opt2
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_6_opt3
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_6_opt4
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_7
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_7_opt1
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_7_opt2
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_7_opt3
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_7_opt4
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_8
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_8_opt1
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_8_opt2
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_8_opt3
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_8_opt4
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_9
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_9_opt1
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_9_opt2
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_9_opt3
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_9_opt4
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_10
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_10_opt1
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_10_opt2
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_10_opt3
import gero.composeapp.generated.resources.quiz_frasi_avverbiali_10_opt4

fun getFrasiAvverbialiContent(): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_2,
            face = Faces.Sad,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_3,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_4,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "O34-G36:D21-M17-V28-X1:F1A-N35:N35:N35",
                        rtl = false,
                        cart = false,
                        size = 56.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_5,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_7,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_8,
            face = Faces.Happy,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_9,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_10,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_11,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_12,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_13,
            face = Faces.Happy,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_14,
            face = Faces.Surprised,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_15,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_16,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-V28-X1:F1A-G17-O1h2:Z1",
                        rtl = false,
                        cart = false,
                        size = 64.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_17,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_frasi_avverbiali,
            content = Res.string.exp_content_frasi_avverbiali_18,
            face = Faces.Happy,
            character = Characters.Nilo,
        )
    )
}

fun getFrasiAvverbialiQuizContent(): List<IQuizContent> {
    return listOf(
        TrueFalseContent(
            text = Res.string.quiz_frasi_avverbiali_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_frasi_avverbiali_2,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_frasi_avverbiali_3,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_frasi_avverbiali_4,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_frasi_avverbiali_5,
            correct = true
        ),
        SingleSelectionContent(
            text = Res.string.quiz_frasi_avverbiali_6,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_frasi_avverbiali_6_opt1, correct = true),
                Option(Res.string.quiz_frasi_avverbiali_6_opt2, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_6_opt3, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_6_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_frasi_avverbiali_7,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_frasi_avverbiali_7_opt1, correct = true),
                Option(Res.string.quiz_frasi_avverbiali_7_opt2, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_7_opt3, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_7_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_frasi_avverbiali_8,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_frasi_avverbiali_8_opt1, correct = true),
                Option(Res.string.quiz_frasi_avverbiali_8_opt2, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_8_opt3, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_8_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_frasi_avverbiali_9,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_frasi_avverbiali_9_opt1, correct = true),
                Option(Res.string.quiz_frasi_avverbiali_9_opt2, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_9_opt3, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_9_opt4, correct = false)
            ).shuffled()
        ),
        SingleSelectionContent(
            text = Res.string.quiz_frasi_avverbiali_10,
            detail = "",
            options = listOf(
                Option(Res.string.quiz_frasi_avverbiali_10_opt1, correct = true),
                Option(Res.string.quiz_frasi_avverbiali_10_opt2, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_10_opt3, correct = false),
                Option(Res.string.quiz_frasi_avverbiali_10_opt4, correct = false)
            ).shuffled()
        )
    )
}
